import global from "@/locales/no-NO/global";
import loginPageSteps from "@/locales/no-NO/loginPageSteps";
import error403 from "@/locales/no-NO/errors/403";
import error404 from "@/locales/no-NO/errors/404";
import error500 from "@/locales/no-NO/errors/500";
import error503 from "@/locales/no-NO/errors/503";
import error504 from "@/locales/no-NO/errors/504";
import maintenance from "@/locales/no-NO/auth/maintenance";
import onboarding from "@/locales/no-NO/auth/onboarding";
import login from "@/locales/no-NO/auth/login";
import account from "@/locales/no-NO/account/account";
import mailbox from "@/locales/no-NO/account/mailbox";
import bankstatement from "@/locales/no-NO/account/bankstatement";
import myApps from "@/locales/no-NO/my-apps/myApps";
import contactService from "@/locales/no-NO/about/contactService";
import salesPromotions from "@/locales/no-NO/sales/promotions";
import brochures from "@/locales/no-NO/sales/brochures";
import dashboard from "@/locales/no-NO/dashboard/dashboard";
import staff from "@/locales/no-NO/dashboard/staff";
import promotions from "@/locales/no-NO/promotions";
import points from "@/locales/no-NO/points";
import shop from "@/locales/no-NO/shop/data";
import priceList from "@/locales/no-NO/shop/priceList";
import trainings from "@/locales/no-NO/trainings/trainings";
import vouchers from "@/locales/no-NO/vouchers/vouchers";
import widgets from "@/locales/no-NO/widgets/widgets";
import generateReport from "@/locales/no-NO/generate-report/generateReport";
import wholesaler from "@/locales/no-NO/wholesaler/wholesaler";
import media from "@/locales/no-NO/media/index";
import product from "@/locales/no-NO/product/index";
import message from "@/locales/no-NO/message/index";
import commitmentLetter from "@/locales/no-NO/account/commitmentLetter";
import multiplicator from "@/locales/no-NO/multiplicator";
import toast from "@/locales/no-NO/toast/toast";
import consents from "@/locales/no-NO/consents/consents";
import investment from "@/locales/no-NO/investment/data";
import kickback from "@/locales/no-NO/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  onboarding: onboarding.messages,
  login: login.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  bankstatement: bankstatement.messages,
  myApps: myApps.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  toast: toast.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produktbilder",
    BDriveLinkText: "Lenke til PRODUCT IMAGES-portalen",
  },
}

export default {
  locale: "no-NO",
  messages,
};
